<template>
  <div class="tournament-basic-info">
    <!-- <h2 class="title">{{ $t("title_TournamentSettings") }}</h2>
    <p class="subtitle">{{ $t("competitionDescription") }}</p> -->

    <div class="info-card">
      <v-form>
        <v-text-field :label="$t('nameLabel')"
          :placeholder="$t('namePlaceholder', { name: this.$store.state.clubMember?.club?.name })"
          v-model="tournamentName" :rules="tournamentNameRules" counter="28" outlined :disabled="isTournamentStarted"
          :hint="isTournamentStarted ? $t('cannotEditAfterStart') : ''" :persistent-hint="isTournamentStarted"
          @input="checkForChanges" />

        <div class="dates-container">
          <div class="date-time-group">
            <v-menu ref="startMenu" v-model="startMenu" :close-on-content-click="false" transition="scale-transition"
              offset-y min-width="auto" :disabled="isTournamentStarted">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="startDate" :label="$t('startDate')" :error-messages="startDateError" readonly
                  v-bind="attrs" v-on="on" outlined dense class="date-field" @input="validateForm"
                  :disabled="isTournamentStarted"
                  :hint="isTournamentStarted ? $t('cannotEditDatesAfterStart') : ''"
                  :persistent-hint="isTournamentStarted">
                  <template v-slot:append>
                    <i class="fa-regular fa-calendar"></i>
                  </template>
                </v-text-field>
              </template>
              <v-date-picker v-model="startDate" no-title :min="minStartDate"
                @input="handleStartDateSelected"></v-date-picker>
            </v-menu>

            <v-tooltip bottom max-width="300" color="var(--v-mainGreen-base)" content-class="utc-tooltip-content"
              nudge-bottom="-10">
              <template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
                <v-text-field v-bind="tooltipAttrs" v-on="tooltipOn" v-model="startTime" :label="$t('startTime')"
                  :placeholder="'09:00'" :hint="$t('timeFormat24hr')" :error-messages="startTimeError" outlined dense
                  class="time-field" maxlength="5" @input="checkForChanges" @blur="formatTime('start')"
                  :disabled="isTournamentStarted">
                  <template v-slot:append>
                    <v-icon small color="mainGreen">fa-info-circle</v-icon>
                  </template>
                </v-text-field>
              </template>
              <span class="white--text">{{ $t('utcTooltip') }}</span>
            </v-tooltip>
            <!-- <div class="field-helper">
              <span v-html="$t('utc5HelperText')"></span>
            </div> -->
          </div>

          <div class="date-time-group">
            <v-menu ref="endMenu" v-model="endMenu" :close-on-content-click="false" transition="scale-transition"
              offset-y min-width="auto" :disabled="isTournamentStarted">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="endDate" :label="$t('endDate')" :error-messages="endDateError" readonly
                  v-bind="attrs" v-on="on" outlined dense class="date-field" @input="checkForChanges"
                  :disabled="isTournamentStarted"
                  :hint="isTournamentStarted ? $t('cannotEditDatesAfterStart') : ''"
                  :persistent-hint="isTournamentStarted">
                  <template v-slot:append>
                    <i class="fa-regular fa-calendar"></i>
                  </template>
                </v-text-field>
              </template>
              <v-date-picker v-model="endDate" no-title :min="minEndDate"
                @input="handleEndDateSelected"></v-date-picker>
            </v-menu>

            <v-tooltip bottom max-width="300" color="var(--v-mainGreen-base)" content-class="utc-tooltip-content"
              nudge-bottom="-10">
              <template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
                <v-text-field v-bind="tooltipAttrs" v-on="tooltipOn" v-model="endTime" :label="$t('endTime')"
                  :placeholder="'18:00'" :hint="$t('timeFormat24hr')" :error-messages="endTimeError" outlined dense
                  class="time-field" maxlength="5" @input="checkForChanges" @blur="formatTime('end')"
                  :disabled="isTournamentStarted">
                  <template v-slot:append>
                    <v-icon small color="mainGreen">fa-info-circle</v-icon>
                  </template>
                </v-text-field>
              </template>
              <span class="white--text">{{ $t('utcTooltip') }}</span>
            </v-tooltip>
          </div>
        </div>


        <v-select class="padding-text" v-model="tournamentLanguage" :items="availableLanguages" :label="$t('tournamentLanguage')"
          :hint="$t('competitionLanguage')" item-text="name" item-value="code" outlined dense persistent-hint
          @input="checkForChanges">
          <template v-slot:selection="{ item }">
            <div class="language-selection">
              <Flag :code="item.flag" :squared="false" class="flag-small" />
              <span class="language-name-small">{{ item.name }}</span>
            </div>
          </template>
          <template v-slot:item="{ item }">
            <v-list-item-avatar size="24">
              <Flag :code="item.flag" :squared="false" />
            </v-list-item-avatar>
            <v-list-item-title>{{ item.name }}</v-list-item-title>
          </template>
        </v-select>

        <v-text-field class="padding-text" v-model="tournamentFAQs" :label="$t('faqs')" :error-messages="faqsError" :hint="$t('competitionUrl')"
          :counter="maxUrlName" persistent-hint outlined dense @input="validateForm">
          <template v-slot:append>
            <i class="fa-regular fa-link"></i>
          </template>
        </v-text-field>

        <v-text-field class="padding-text"  v-model="tournamentTerms" :label="$t('TermsAndConditions')" :error-messages="termsError"
          :counter="maxUrlName" :disabled="isTournamentStarted" outlined dense
          :hint="isTournamentStarted ? $t('cannotEditAfterStartUrl') : $t('defautlTermsAndConditions')"
          persistent-hint  @input="validateForm">
          <template v-slot:append>
            <i class="fa-regular fa-file-contract"></i>
          </template>
        </v-text-field>
      </v-form>
    </div>
  </div>
</template>

<script>
import Repository from '../../../../repositories/tournament';
import { mapMutations } from 'vuex';

export default {
  name: "BasicsTab",
  props: {
    setNextBtnDisabled: { type: Function, required: false },
  },
  data: () => ({
    startMenu: false,
    endMenu: false,
    startDateError: "",
    endDateError: "",
    startTimeError: "",
    endTimeError: "",
    tournamentName: "",
    startDate: "",
    endDate: "",
    startTime: "",
    endTime: "",
    originalStartTime: null, // Store original start time
    originalEndTime: null, // Store original end time
    faqsError: "",
    termsError: "",
    minStartDate: new Date().toISOString().substr(0, 10),
    maxNameLength: 28,
    maxUrlName: 100,
    tournamentLanguage: "",
    tournamentFAQs: "",
    tournamentTerms: "",
    initialValues: null, // Store initial values to detect changes
    availableLanguages: [
      { code: "en", name: "English", flag: "US" },
      { code: "es", name: "Español", flag: "ES" },
      { code: "ko", name: "한국어", flag: "KR" },
      { code: "th", name: "ไทย", flag: "TH" },
      { code: "pt", name: "Português", flag: "PT" },
      { code: "zh", name: "简体中文", flag: "CN" },
      { code: "zh-Hant", name: "繁體中文", flag: "CN" },
      { code: "vi", name: "Tiếng Việt", flag: "VN" },
    ],
  }),
  computed: {
    tournamentSummary() {
      return this.$store.state.tournament;
    },
    isTournamentStarted() {
      if (!this.tournamentSummary || !this.tournamentSummary.startTime) return false;
      const now = new Date();
      const startTime = new Date(this.tournamentSummary.startTime);
      return now >= startTime;
    },
    tournamentNameRules() {
      return [
        t => !!t || this.$t('nameRequiredValidation'),
        t => (t && t.length <= 28) || this.$t('maxCharactersValidation', { max: 28 }),
      ];
    },
    minEndDate() {
      return this.startDate || this.minStartDate;
    },
  },
  mounted() {
    if (this.tournamentSummary) {
      this.init();
    }
    // Disable save button initially
    if (this.setNextBtnDisabled) {
      this.setNextBtnDisabled(true);
    }
  },
  watch: {
    tournamentSummary: {
      handler(newVal) {
        if (newVal && !this.initialValues) {
          this.init();
        }
      },
      immediate: true
    }
  },
  methods: {
    ...mapMutations(['setTournament']),
    init() {
      this.tournamentName = this.tournamentSummary.tournamentName;
      // Check for faqsUrl in tournamentSettings first, then in root object
      if ( this.tournamentSummary.tournamentSettings && 
          this.tournamentSummary.tournamentSettings.faqsUrl !== undefined
      ) {
        this.tournamentFAQs =
          this.tournamentSummary.tournamentSettings.faqsUrl || "";
      } else if (this.tournamentSummary.faqsUrl !== undefined) {
        this.tournamentFAQs = this.tournamentSummary.faqsUrl || "";
      } else {
        this.tournamentFAQs = "";
      }

      if(this.tournamentSummary.tournamentSettings && this.tournamentSummary.tournamentSettings.termsCondition  !== undefined){
        this.tournamentTerms = this.tournamentSummary.tournamentSettings.termsCondition || "";
      } else if (this.tournamentSummary.termsCondition !== undefined) {
        this.tournamentTerms = this.tournamentSummary.termsCondition || "";
      } else {
        this.tournamentTerms = "";
      }  

      // Check for tournamentLanguage in tournamentSettings
      if (
        this.tournamentSummary.tournamentSettings &&
        this.tournamentSummary.tournamentSettings.mainLanguage
      ) {
        this.tournamentLanguage = this.tournamentSummary.tournamentSettings.mainLanguage;
      } else {
        this.tournamentLanguage = this.$i18n.locale;
      }

      // Store original times to preserve them when updating
      this.originalStartTime = new Date(this.tournamentSummary.startTime);
      this.originalEndTime = new Date(this.tournamentSummary.endTime);

      // Extract time components for the time inputs (in HH:MM format)
      const formatTime = (date) => {
        const hours = date.getUTCHours().toString().padStart(2, "0");
        const minutes = date.getUTCMinutes().toString().padStart(2, "0");
        return `${hours}:${minutes}`;
      };

      this.startTime = formatTime(this.originalStartTime);
      this.endTime = formatTime(this.originalEndTime);

      // Extract only dates for the date picker
      this.startDate = new Date(this.tournamentSummary.startTime).toISOString().substr(0, 10);
      this.endDate = new Date(this.tournamentSummary.endTime).toISOString().substr(0, 10);
      // Store initial values for change detection
      this.initialValues = {
        tournamentName: this.tournamentName,
        startDate: this.startDate,
        endDate: this.endDate,
        startTime: this.startTime,
        endTime: this.endTime,
        tournamentLanguage: this.tournamentLanguage,
        tournamentFAQs: this.tournamentFAQs,
        tournamentTerms: this.tournamentTerms
      };
    },
    validateForm() {
      this.startDateError = "";
      this.endDateError = "";
      this.startTimeError = "";
      this.endTimeError = "";
      this.faqsError = "";
      this.termsError = "";

      if (this.tournamentName.length > this.maxNameLength) {
        this.nameError = this.$t("maxLengthError");
      }

      if (this.startTime && !this.isValidTimeFormat(this.startTime)) {
        this.startTimeError = this.$t("invalidTimeFormat");
      }

      if (this.endTime && !this.isValidTimeFormat(this.endTime)) {
        this.endTimeError = this.$t("invalidTimeFormat");
      }

      if (this.tournamentFAQs && !this.isValidUrl(this.tournamentFAQs)) {
        this.faqsError = this.$t("invalidUrlError");
      }

      if (this.tournamentTerms && !this.isValidUrl(this.tournamentTerms)) {
        this.termsError = this.$t("invalidUrlError");
      }

      const isValid =
        this.tournamentName &&
        this.tournamentName.length <= this.maxNameLength &&
        this.startDate &&
        this.endDate &&
        this.startTime &&
        this.endTime &&
        this.tournamentLanguage &&
        this.isValidTimeFormat(this.startTime) &&
        this.isValidTimeFormat(this.endTime) &&
        this.validateDateTime() &&
        (!this.tournamentFAQs || this.isValidUrl(this.tournamentFAQs)) &&
        (!this.tournamentTerms || this.isValidUrl(this.tournamentTerms));

      // Don't override the button state here - let checkForChanges handle it
      // This method is only for validation, not for button state management

      // Si también quieres que el padre sepa si es válido:
      this.$emit("validity", { isValid });
      this.checkForChanges();
      return isValid;
    },

    validateDateTime() {
      if (!this.startDate || !this.endDate || !this.startTime || !this.endTime)
        return false;

      const startDateTime = new Date(`${this.startDate}T${this.startTime}`);
      const endDateTime = new Date(`${this.endDate}T${this.endTime}`);

      if (endDateTime <= startDateTime) {
        this.endDateError = this.$t("endDateTimeError");
        return false;
      }
      return true;
    },
   
    isValidTimeFormat(time) {
      const timePattern = /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/;
      return timePattern.test(time);
    },

    formatTime(timeType) {
      let time = timeType === "start" ? this.startTime : this.endTime;
      if (!time) return;

      time = time.replace(/[^\d:]/g, "");

      if (time.length === 1 || time.length === 2) {
        const hour = parseInt(time);
        if (hour >= 0 && hour <= 23)
          time = hour.toString().padStart(2, "0") + ":00";
      } else if (time.length === 3 && time.includes(":")) {
        let [hour, minute] = time.split(":");
        hour = parseInt(hour);
        minute = parseInt(minute || 0);
        if (hour >= 0 && hour <= 23 && minute >= 0 && minute <= 59) {
          time =
            hour.toString().padStart(2, "0") +
            ":" +
            minute.toString().padStart(2, "0");
        }
      } else if (time.length === 4 && !time.includes(":")) {
        const hour = parseInt(time.substr(0, 2));
        const minute = parseInt(time.substr(2, 2));
        if (hour >= 0 && hour <= 23 && minute >= 0 && minute <= 59) {
          time =
            hour.toString().padStart(2, "0") +
            ":" +
            minute.toString().padStart(2, "0");
        }
      }

      if (timeType === "start") this.startTime = time;
      else this.endTime = time;

      this.validateForm();
    },

    isValidUrl(url) {
      const urlPattern =
        /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_+.~#?&/=]*)$/;
      return url.trim() === "" || urlPattern.test(url.trim());
    },

    handleStartDateSelected(date) {
      this.startDate = date;
      this.startMenu = false;
      
      // Reset end date if it's before new start date
      if (this.endDate) {
        const end = new Date(this.endDate);
        const start = new Date(date);
        if (end <= start) {
          this.endDate = "";
        }
      }
      
      this.checkForChanges();
    },

    handleEndDateSelected(date) {
      this.endDate = date;
      this.endMenu = false;
      this.checkForChanges();
    },

    checkForChanges() {
      if (!this.initialValues) return;
      const hasChanges = 
        this.tournamentName !== this.initialValues.tournamentName ||
        this.startDate !== this.initialValues.startDate ||
        this.endDate !== this.initialValues.endDate ||
        this.startTime !== this.initialValues.startTime ||
        this.endTime !== this.initialValues.endTime ||
        this.tournamentLanguage !== this.initialValues.tournamentLanguage ||
        this.tournamentFAQs !== this.initialValues.tournamentFAQs ||
        this.tournamentTerms !== this.initialValues.tournamentTerms;

      // Enable/disable save button based on changes and form validity
      if (this.setNextBtnDisabled) {
        const isValid = this.tournamentName &&
          this.tournamentName.length <= this.maxNameLength &&
          this.startDate &&
          this.endDate &&
          this.startTime &&
          this.endTime &&
          this.tournamentLanguage &&
          this.isValidTimeFormat(this.startTime) &&
          this.isValidTimeFormat(this.endTime) &&
          this.validateDateTime() &&
          (!this.tournamentFAQs || this.isValidUrl(this.tournamentFAQs)) &&
          (!this.tournamentTerms || this.isValidUrl(this.tournamentTerms));

        // Disable if no changes or form is invalid
        this.setNextBtnDisabled(!hasChanges || !isValid);
      }
    },

    saveTournamentSettings() {
      // Validate form before saving
      if (!this.validateForm()) {
        return;
      }

      // Prepare dates
      let formalStartDate = new Date(`${this.startDate}T${this.startTime}:00.000Z`);
      let formalEndDate = new Date(`${this.endDate}T${this.endTime}:00.000Z`);

      // If tournament has started, keep original start date
      if (this.isTournamentStarted) {
        formalStartDate = new Date(this.tournamentSummary.startTime);
      }

      // Validate dates
      if (formalStartDate >= formalEndDate) {
        this.endDateError = this.$t('alerts_TournamentSettings.notBefore');
        this.$emit('save-error', {
          message: this.$t('alerts_TournamentSettings.notBefore')
        });
        return;
      }

      let basicsData = {
        tournamentId: this.tournamentSummary.tournamentId,
        tournamentName: this.isTournamentStarted ? this.tournamentSummary.tournamentName : this.tournamentName,
        startTime: formalStartDate.toISOString(),
        endTime: formalEndDate.toISOString(),
        faqsUrl: this.tournamentFAQs,
        termsCondition: this.tournamentTerms,
        mainLanguage: this.tournamentLanguage
      };

      Repository.editTournamentBasics(basicsData).then((response) => {
        if (response.status < 400 && response.data) {
          // Update initial values after successful save
          this.initialValues = {
            tournamentName: this.tournamentName,
            startDate: this.startDate,
            endDate: this.endDate,
            startTime: this.startTime,
            endTime: this.endTime,
            tournamentLanguage: this.tournamentLanguage,
            tournamentFAQs: this.tournamentFAQs,
            tournamentTerms: this.tournamentTerms           
          };
          
          // Disable save button after successful save
          if (this.setNextBtnDisabled) {
            this.setNextBtnDisabled(true);
          }

          // Refresh tournament data and update store
          Repository.getTournamentOverview(this.tournamentSummary.tournamentId).then((response) => {
            if (response.status < 400) {
              this.setTournament(response.data);
            }
          });

          // Emit success event to parent
          this.$emit('save-success', {
            message: this.$t('alerts_TournamentSettings.edited')
          });
        }
        else {
          this.$emit('save-error', {
            message: this.$t('alerts.errorOccurred')
          });
        }
      }).catch(() => {
        this.$emit('save-error', {
          message: this.$t('alerts.errorOccurred')
        });
      });
    },

  },
};
</script>

<style lang="scss" scoped>
.theme--light .tournament-basic-info {
  --disabled-bg: #f5f5f5;
  --disabled-border: #e0e0e0;
  --disabled-text: #9e9e9e;
  --disabled-icon: #9e9e9e;
}

.theme--dark .tournament-basic-info {
  --disabled-bg: rgba(255, 255, 255, 0.06);
  --disabled-border: rgba(255, 255, 255, 0.14);
  --disabled-text: rgba(255, 255, 255, 0.55);
  --disabled-icon: rgba(255, 255, 255, 0.45);
}
::v-deep .v-input--is-disabled .v-input__control .v-input__slot {
  background-color: var(--disabled-bg) !important;
  border-color: var(--disabled-border) !important;
}

::v-deep .v-text-field--outlined.v-input--is-disabled .v-input__control .v-input__slot fieldset {
 box-shadow: none !important;
}

::v-deep .v-text-field--outlined.v-input--is-disabled:hover .v-input__control .v-input__slot fieldset {
 box-shadow: none !important;
}

::v-deep .v-input--is-disabled input,
::v-deep .v-input--is-disabled textarea {
  color: var(--disabled-text) !important;
  -webkit-text-fill-color: var(--disabled-text) !important;
}

::v-deep .v-input--is-disabled .v-label {
  color: var(--disabled-text) !important;
}

::v-deep .v-input--is-disabled .v-select__selection {
  color: var(--disabled-text) !important;
}

::v-deep .v-input--is-disabled .v-icon {
  color: var(--disabled-icon) !important;
}
.field-helper {
  font-size: 12px;
  color: var(--v-textSecondary-base);
  margin-top: 4px;
  font-family: "Avenir", sans-serif;

  ::v-deep a.helper-link {
    color: var(--v-mainGreen-base);
    font-weight: 500;
    text-decoration: none;
    margin: 0 2px;

    &:hover {
      text-decoration: underline;
    }
  }
}

.info-card {
        background-color: var(--v-cardBackground-base);
        border: 1px solid #ededed;
        border-radius: 10px;
        padding: 76px 60px 50px 60px;

        .v-form{
            max-width: 720px;
            margin: auto;
        }
        
        .dates-container {
            display: flex;
            gap: 24px;
            margin-bottom: 16px;

            @media (max-width: 768px) {
                flex-direction: column;
                gap: 16px;
            }

            .date-time-group {
                flex: 1;
                display: flex;
                flex-direction: column;
                gap: 12px;

                @media (min-width: 769px) {
                    .date-field {
                        margin-bottom: 8px;
                    }
                }

                @media (max-width: 768px) {
                    .date-field, .time-field {
                        width: 100%;
                    }
                }
            }

            .date-field, .time-field {
                width: 100%;
            }
        }
    }

  .theme--dark .info-card {
  border-color: #424242;
}

.padding-text{
  padding-bottom: 12px;
}



</style>
